import { User } from "model/user";

/**
 * Whether the account has the Search Agent: the entitlement and the Search Agent turned on, the
 * same pair that shows the lead's Search Agent tab.
 */
export const hasSearchAgent = (user: User | null | undefined) => {
	return !!user
		&& user.permissions.aiSearchAgent === true
		&& user.searchAgentEnabled === true;
};
